// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1ucHk","choiceBoxes":"toolbarselects_choiceBoxes__1nA44","simpleField":"toolbarselects_simpleField__16vg4"};